import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f4b20b28"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "用户管理", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "人工出题", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "图形推理", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "平面图形推理", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "文字推理", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "黑盒光路推理", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "跷跷板", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "价值计算", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "立体展开图", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "立体纽结理论", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "套题管理", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "授课计划", -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "教学管理", -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "系统设置", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "模拟考试", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_User = _resolveComponent("User");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  const _component_Tickets = _resolveComponent("Tickets");
  const _component_el_sub_menu = _resolveComponent("el-sub-menu");
  const _component_TakeawayBox = _resolveComponent("TakeawayBox");
  const _component_FolderChecked = _resolveComponent("FolderChecked");
  const _component_Postcard = _resolveComponent("Postcard");
  const _component_el_menu = _resolveComponent("el-menu");
  const _component_el_aside = _resolveComponent("el-aside");
  return _openBlock(), _createBlock(_component_el_aside, {
    class: "menu"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_menu, {
      router: true,
      "default-active": _ctx.$route.path
    }, {
      default: _withCtx(() => [_createVNode(_component_el_menu_item, {
        route: "/m/user/list",
        index: "/m/user/list"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_User)]),
          _: 1
        }), _hoisted_1]),
        _: 1
      }), _createVNode(_component_el_sub_menu, {
        index: "1"
      }, {
        title: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_Tickets)]),
          _: 1
        }), _hoisted_2]),
        default: _withCtx(() => [_createVNode(_component_el_menu_item, {
          route: "/m/logical/list",
          index: "/m/logical/list"
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          route: "/m/logical2d/list",
          index: "/m/logical2d/list"
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          route: "/m/text/logical/list",
          index: "/m/text/logical/list"
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          route: "/m/optical-path/list",
          index: "/m/optical-path/list"
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          route: "/m/seesaw/list",
          index: "/m/seesaw/list"
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          route: "/m/price/calculate/list",
          index: "/m/price/calculate/list"
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          route: "/m/unfolding3d/list",
          index: "/m/unfolding3d/list"
        }, {
          default: _withCtx(() => [_hoisted_9]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          route: "/m/knot/list",
          index: "/m/knot/list"
        }, {
          default: _withCtx(() => [_hoisted_10]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_menu_item, {
        route: "/m/question/tpl/list",
        index: "/m/question/tpl/list"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_TakeawayBox)]),
          _: 1
        }), _hoisted_11]),
        _: 1
      }), _createVNode(_component_el_menu_item, {
        route: "/m/teaching/plan/list",
        index: "/m/teaching/plan/list"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_FolderChecked)]),
          _: 1
        }), _hoisted_12]),
        _: 1
      }), _createVNode(_component_el_menu_item, {
        route: "/m/teaching/class",
        index: "/m/teaching/class"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_Postcard)]),
          _: 1
        }), _hoisted_13]),
        _: 1
      }), _createVNode(_component_el_menu_item, {
        route: "/m/setting",
        index: "/m/setting"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_Postcard)]),
          _: 1
        }), _hoisted_14]),
        _: 1
      }), _createVNode(_component_el_menu_item, {
        route: "/m/exam",
        index: "/m/exam"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_TakeawayBox)]),
          _: 1
        }), _hoisted_15]),
        _: 1
      })]),
      _: 1
    }, 8, ["default-active"])]),
    _: 1
  });
}